// extracted by mini-css-extract-plugin
export default {"wxLaunchAppBox":"index_wxLaunchAppBox_HrW7m"};